// extracted by mini-css-extract-plugin
export var dropdownButton = "NextEventDetails-module--dropdownButton--01b12";
export var dropdownIcon = "NextEventDetails-module--dropdownIcon--a4d3b";
export var dropdownLabel = "NextEventDetails-module--dropdownLabel--54178";
export var dropdownMenu = "NextEventDetails-module--dropdownMenu--6e9e2";
export var dropdownRoot = "NextEventDetails-module--dropdownRoot--79b3b";
export var item = "NextEventDetails-module--item--16b63";
export var upcomingDates = "NextEventDetails-module--upcomingDates--13be6";